import React, { useState } from "react";
import Wrapper from "../../Wrapper";
import technologyStyles from "./technology.module.css";
import data from "../../data.json";
import pics0 from "../../assets/technology/image-launch-vehicle-portrait.jpg";
import pics1 from "../../assets/technology/image-spaceport-portrait.jpg";
import pics2 from "../../assets/technology/image-space-capsule-portrait.jpg";
import pics00 from "../../assets/technology/image-launch-vehicle-landscape.jpg";
import pics11 from "../../assets/technology/image-spaceport-landscape.jpg";
import pics22 from "../../assets/technology/image-space-capsule-landscape.jpg";
import { nanoid } from "nanoid";

const portraitImages = [pics0, pics1, pics2];
const landscapeImages = [pics00, pics11, pics22];
const technologyData = data.technology;

const TechnologyItems = () => {
  const [portrait, setPortrait] = useState(pics0);
  const [landscape, setLandscape] = useState(pics00);
  const [spaceLaunch] = useState(technologyData);
  const [selectedTechnologyIndex, setSelectedTechnologyIndex] = useState(0);

  const { name, description } = spaceLaunch[selectedTechnologyIndex];

  const imageChangeHandler = (index) => {
    setPortrait(portraitImages[index]);
    setSelectedTechnologyIndex(index);
    setLandscape(landscapeImages[index]);
  };

  return (
    <Wrapper>
      {technologyData.length > 0 && (
        <div className={technologyStyles.centralize}>
          <main className={technologyStyles.body}>
            <div className={technologyStyles.left}>
              <div className={technologyStyles.image}>
                <picture>
                  <source media="(min-width: 769px)" srcSet={portrait} />
                  <img src={landscape} alt={name} width="100%" />
                </picture>
              </div>
            </div>
            <aside className={technologyStyles.right}>
              <nav>
                {technologyData.map((item, index) => (
                  <div className={technologyStyles.buttons} key={nanoid()}>
                    <button
                      type="button"
                      onClick={() => imageChangeHandler(index)}
                      className={technologyStyles.btn}
                    >
                      {index + 1}
                    </button>
                  </div>
                ))}
              </nav>
              <div className={technologyStyles.text}>
                <p className={technologyStyles.terminology}>
                  The Terminology...
                </p>
                <h1>{name}</h1>
                <p className={technologyStyles.description}>{description}</p>
                {/* Add any additional content here */}
              </div>
            </aside>
          </main>
        </div>
      )}
    </Wrapper>
  );
};

export default TechnologyItems;
